// apolloClient.js
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const apiUrl = `${baseUrl}/api`;

const httpLink = createHttpLink({
  uri: apiUrl,
  fetchOptions: {
    mode: "cors",
  },
});

export const getAuthLink = (accessToken, idToken) =>
  setContext((_, { headers }) => ({
    headers: {
      ...headers,
      Authorization: `Bearer ${accessToken}`,
      id_token: idToken,
    },
  }));

export const createApolloClient = (accessToken, idToken) =>
  new ApolloClient({
    link: getAuthLink(accessToken, idToken).concat(httpLink),
    cache: new InMemoryCache(),
  });
